import { render, staticRenderFns } from "./MarketersDetails.vue?vue&type=template&id=61e0820c&"
import script from "./MarketersDetails.vue?vue&type=script&lang=js&"
export * from "./MarketersDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports